import styled from 'styled-components';

import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  row-gap: 40px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const SchoolItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const SchoolImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  margin-bottom: 16px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}px) {
    width: 50%;
    margin-bottom: 0;
  }
`;

export const SchoolImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const SchoolTexts = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
